import React, { useState, useEffect, useCallback, memo } from 'react';
import {Paper,InputBase , Button, Drawer, IconButton, List} from '@material-ui/core';
import {Close as CloseIcon,Menu as MenuIcon} from '@material-ui/icons';
import { useTheme } from '@material-ui/styles';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';

import useStyles from './styles';
import SidebarLink from './components/SidebarLink/SidebarLink';
import { useLayoutState, useLayoutDispatch, toggleSidebar } from '../../context/LayoutContext';
import { getSidebarLinks } from '../../store/actions/dashboard.actions';
import SkeletonShell from '../../components/Skeleton/index';
import { Scrollbars } from 'react-custom-scrollbars';
import { pathOr } from "ramda";
import BrandLogo from "../BrandLogo";

function Sidebar({ location, history }) {
	const classes = useStyles();
	const theme = useTheme();
	
	const { sidebarLinks, sidebarLoading } = useSelector((state) => state.dashboard);
	const [menu, setMenu] = useState(pathOr([],["sidebarLinks","attributes"],useSelector((state) => state.dashboard)));
	const [searchString, setSearchString]=useState('');
	const { isAuthenticated } = useSelector((state) => state.auth);
	const userData = pathOr(
		undefined,
		["data", "attributes"],
		useSelector((state) => state.config.currentUserData),
	);
	// console.log("$$$$$$$$$$$$$$$$$", userData)
	const dispatch = useDispatch();
	const layoutState = useLayoutState();

	const { isSidebarOpened } = useLayoutState();
	const layoutDispatch = useLayoutDispatch();

	const [isPermanent, setPermanent] = useState(true);

	const getSidebarData = useCallback(
		() => {
			isAuthenticated && dispatch(getSidebarLinks());
		},
		[dispatch, isAuthenticated]
	);

	useEffect(() => getSidebarData(), [getSidebarData]);

	useEffect(function () {
		window.addEventListener('resize', handleWindowWidthChange);
		handleWindowWidthChange();
		return function cleanup() {
			window.removeEventListener('resize', handleWindowWidthChange);
		};
	});
	const navigateToUserDetail = () => {
		// setProfileMenu(null);
		history.push(`/app/detailview/Users/${userData.id}`);
	};
	const handleSearchModule = (e)=>{
		let newArr = {};
		let searchVal = e.target.value;
		searchVal = searchVal.trim();
		setSearchString(searchVal);
		searchVal = searchVal.toLowerCase();
		
		Object.keys(sidebarLinks.attributes).map((sidebarKey,index) => {
			let moduleName = pathOr("",[sidebarKey,"label"],sidebarLinks.attributes);
			 moduleName = moduleName.trim().toLowerCase();
			if(moduleName.indexOf(searchVal) > -1)
			{
				newArr[sidebarKey] = sidebarLinks.attributes[sidebarKey];				
			}
		});
		setMenu(newArr);
	}
	const clearSearch = ()=>{
		setSearchString('');
		setMenu(sidebarLinks.attributes);
	}
	useEffect(()=>{
		setMenu(sidebarLinks.attributes);
	},[sidebarLinks.attributes]);
	
	const renderSidebarLinks = () => {
		
		return menu && Object.keys(menu).map((sidebarKey) => {
			/* Start Modified By Harshal on 04022021*/
			let ACLAccess = pathOr([],["attributes",sidebarKey,"access"],sidebarLinks);
			let recordsRecent = Object.values(pathOr([],["attributes",sidebarKey,"RecentViews"],sidebarLinks));
			let recordsFav = Object.values(pathOr([],["attributes",sidebarKey,"FavoriteRecords"],sidebarLinks));

			let children = ()=>{				
				let data=[];
				if(ACLAccess.includes('edit'))
				{
					data.push({ label: `Create ${sidebarLinks.attributes[sidebarKey]["label"]}`, icon: { icon: 'fa-plus' }, link: `/app/createview/${sidebarKey}` });
				}
				if(ACLAccess.includes('access','view','list'))
				{
					data.push({ label: `View ${sidebarLinks.attributes[sidebarKey]["label"]}`, icon: { icon: 'fa-eye' }, link: `/app/${sidebarKey}` });
				}
				data.push({ label: "Recently Viewed", icon: { icon: 'fa-eye-slash' }, type: "title", link: `#` });
				
				recordsRecent.map((datarecent, index) => {
				if (datarecent && index<5) {
						data.push({ label: `${datarecent.item_summary}`, icon: { icon: sidebarLinks.attributes[sidebarKey]["icon"].icon }, link: ACLAccess.includes('view')?`/app/detailview/${sidebarKey}/${datarecent.item_id}`:'#' });
					}
				});
				
				data.push({ label: "Favorites", type: "title", link: `#` });
				recordsFav.map((datafav, index) => {
				if (datafav && index<5) {
						data.push({ label: `${datafav.attributes.name}`, icon: { icon: sidebarLinks.attributes[sidebarKey]["icon"].icon }, link: ACLAccess.includes('view')?`/app/detailview/${sidebarKey}/${datafav.id}`:'#'});
					}
				});
				return data;
			}
			/* End Modified By Harshal on 04022021*/
			return (
				<SidebarLink
					key={sidebarKey}					
					module={sidebarKey}
					location={location}
					isSidebarOpened={isSidebarOpened}
					label={pathOr("",['attributes',sidebarKey,'label'],sidebarLinks)}
					link={`/app/${sidebarKey}`}
					icon={pathOr("",['attributes',sidebarKey,'icon'],sidebarLinks)}
					children={children()}
				/>
			);
		});
	};
	
	return (
		<>

			<Drawer
				variant="permanent"//{isPermanent ? 'permanent' : 'temporary'}
				className={classNames(classes.drawer, {
					[classes.drawerOpen]: isSidebarOpened,
					[classes.drawerClose]: !isSidebarOpened
				})}
				classes={{
					paper: classNames({
						[classes.drawerOpen]: isSidebarOpened,
						[classes.drawerClose]: !isSidebarOpened
					})
				}}
				open={isSidebarOpened}
			>
				<Paper className={classes.sidebarLogo}>
					<Button
						size="medium"
						key="profile-menu"
						color="inherit"
						onClick={() => toggleSidebar(layoutDispatch)}
						className={classNames(
							classes.headerMenuButton,
							classes.headerMenuButtonCollapse,
						)} >
						<IconButton>
							<MenuIcon
								classes={{
									root: layoutState.isSidebarOpened
										? classNames(classes.menuButtonIconOpen, classes.headerIcon,
											classes.headerIconCollapse)
										: classNames(classes.menuButtonIconClosed, classes.headerIcon,
											classes.headerIconCollapse)
								}}
							/>
						</IconButton>
					</Button>
					{isSidebarOpened && <BrandLogo /> }
				</Paper>
				{
				isSidebarOpened &&
				<Paper className={classes.searchBox}>
					<InputBase
					className={classes.searchInput}
					placeholder="Search..."
					inputProps={{ 'aria-label': 'search' }}
					onChange={handleSearchModule}
					value={searchString}
					/>
					{
						searchString &&
						<IconButton className={classes.searchIconButton} aria-label="search" onClick={()=>clearSearch()}>
							<CloseIcon />
						</IconButton>
					}
				</Paper>
				}
				{/* <>
				{menu && Object.keys(menu).map((moduleName)=>(
					<p>{moduleName}</p>
				))
					}
				</> */}
				<Scrollbars autoHide={true}>
					{
						sidebarLoading ? (<SkeletonShell layout="sidebar" />) : (
							<List className={classes.sidebarList}>
								{menu && renderSidebarLinks()}
							</List>
						)
					}
				</Scrollbars >
			</Drawer >
		</>
	);

	function handleWindowWidthChange() {
		var windowWidth = window.innerWidth;
		var breakpointWidth = theme.breakpoints.values.md;
		var isSmallScreen = windowWidth < breakpointWidth;

		if (isSmallScreen && isPermanent) {
			setPermanent(false);
		} else if (!isSmallScreen && !isPermanent) {
			setPermanent(true);
		}
	}
}

export default memo(withRouter(Sidebar));
